/*
 * Soranest card actions: wishlist (heart) + share buttons on product cards.
 * Wishlist is stored in this browser only (localStorage).
 * Share uses the native share sheet on mobile, and falls back to copying the link.
 */
(function () {
  if (window.__soranestCardActionsLoaded) return;
  window.__soranestCardActionsLoaded = true;

  var STORAGE_KEY = 'soranest_wishlist';
  var ACTIVE_CLASS = 'is-active';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode or storage disabled - the button still works for this page view */
    }
  }

  function syncWishlistButtons(root) {
    var saved = readWishlist();
    var buttons = (root || document).querySelectorAll('[data-wishlist-toggle]');
    Array.prototype.forEach.call(buttons, function (button) {
      var handle = button.getAttribute('data-product-handle');
      var isSaved = saved.indexOf(handle) !== -1;
      button.classList.toggle(ACTIVE_CLASS, isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      var label = button.getAttribute(isSaved ? 'data-label-saved' : 'data-label-save');
      if (label) button.setAttribute('aria-label', label);
    });
  }

  function toggleWishlist(button) {
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var saved = readWishlist();
    var index = saved.indexOf(handle);

    if (index === -1) {
      saved.push(handle);
      button.classList.add('soranest-card-action--pop');
      window.setTimeout(function () {
        button.classList.remove('soranest-card-action--pop');
      }, 320);
    } else {
      saved.splice(index, 1);
    }

    writeWishlist(saved);
    syncWishlistButtons();
  }

  var toastTimer = null;

  function showToast(message) {
    var toast = document.getElementById('soranest-card-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'soranest-card-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'absolute';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        document.body.removeChild(field);
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  function shareProduct(button) {
    var url = button.getAttribute('data-share-url');
    var title = button.getAttribute('data-share-title') || document.title;
    if (!url) return;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {
        /* user dismissed the share sheet - nothing to do */
      });
      return;
    }

    copyToClipboard(url).then(function () {
      showToast(button.getAttribute('data-copied-label') || 'Link copied');
    }).catch(function () {
      window.prompt('Copy this link', url);
    });
  }

  document.addEventListener('click', function (event) {
    var wishlistButton = event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(wishlistButton);
      return;
    }

    var shareButton = event.target.closest && event.target.closest('[data-share-product]');
    if (shareButton) {
      event.preventDefault();
      event.stopPropagation();
      shareProduct(shareButton);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncWishlistButtons();
    });
  } else {
    syncWishlistButtons();
  }

  /* Re-sync after sections re-render (filtering, pagination, quick add) */
  document.addEventListener('shopify:section:load', function () {
    syncWishlistButtons();
  });
})();
